import { render, staticRenderFns } from "./pushVivoConfig.vue?vue&type=template&id=46ef8350&scoped=true"
import script from "./pushVivoConfig.vue?vue&type=script&lang=js"
export * from "./pushVivoConfig.vue?vue&type=script&lang=js"
import style0 from "./pushVivoConfig.vue?vue&type=style&index=0&id=46ef8350&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ef8350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ef8350')) {
      api.createRecord('46ef8350', component.options)
    } else {
      api.reload('46ef8350', component.options)
    }
    module.hot.accept("./pushVivoConfig.vue?vue&type=template&id=46ef8350&scoped=true", function () {
      api.rerender('46ef8350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/pushVivoConfig.vue"
export default component.exports